import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import SignIn from './page/Signin';
import ForgotPassword from './page/ForgotPassword';
import ResetPassword from './page/ResetPassword';
import Signin2FA from './page/Signin2FA';
import MagicLogin from './page/MagicLogin';
import Dashboard from './page/Dashboard';
import Profile from './page/Profile';
import Test from './page/Test';
import SignOut from './page/Signout';
import CircularProgress from '@mui/material/CircularProgress';
import {
  selectIsAuthenticated,
  selectAuthLoading,
  selectSessionExpired,
} from './reducer/authSlice';

const UserRoutes = (props) => {
  const [userExist, setUser] = React.useState(false);

  const isAuthenticated = useSelector(selectIsAuthenticated);
  const authLoading = useSelector(selectAuthLoading);
  const sessionExpired = useSelector(selectSessionExpired);

  // While /me is resolving on app mount, don't prematurely redirect.
  if (authLoading) {
    return (
      <div style={{ height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <CircularProgress />
      </div>
    );
  }

  const forceLogoutMessage = sessionExpired ? <>Session expired. Please login again!</> : '';

  return (
    <Routes>
      {/* Dashboard Route */}
      <Route
        path='/v2/user/dashboard'
        element={isAuthenticated ? (
          <Dashboard themeType={props.themeType} changeTheme={props.changeTheme} />
        ) : (
          <Navigate to={process.env.REACT_APP_NAME == "v2-hdfc" ? "/v2/user/signin" : "/v2/user/login"} />
        )}
      />

      {/* Profile Route */}
      <Route
        path='/v2/user/profile'
        element={isAuthenticated ? (
          <Profile themeType={props.themeType} changeTheme={props.changeTheme} />
        ) : (
          <Navigate to="/v2/user/dashboard" />
        )}
      />

      {/* Logout Route */}
      <Route
        path='/v2/user/logout'
        element={
          <SignOut setUser={setUser} userExist={userExist} />
        }
      />

      {/* Test Route */}
      <Route
        path='/v2/user/test'
        element={<Test themeType={props.themeType} changeTheme={props.changeTheme} />}
      />

      {/* Root Route */}
      <Route
        path='/v2/user/'
        element={isAuthenticated ? (
          <Navigate to="/v2/user/dashboard" />
        ) : (
          <SignIn setUser={setUser} userExist={userExist} />
        )}
      />

      {/* Login Route */}
      <Route
        path='/v2/user/login'
        element={isAuthenticated ? (
          <Navigate to="/v2/user/dashboard" />
        ) : (
          <SignIn
            setUser={setUser}
            userExist={userExist}
            forceLogout={forceLogoutMessage}
          />
        )}
      />

      {/* Forgot Password Route */}
      <Route
        path='/v2/user/forgot-password'
        element={
          <ForgotPassword setUser={setUser} userExist={userExist} />
        }
      />

      {/* Reset Password Route */}
      <Route
        path='/v2/user/reset-password'
        element={
          <ResetPassword setUser={setUser} userExist={userExist} />
        }
      />

      {/* Magic Link Login Route */}
      <Route
        path='/v2/user/magic-login'
        element={isAuthenticated ? (
          <Navigate to="/v2/user/dashboard" />
        ) : (
          <MagicLogin setUser={setUser} />
        )}
      />

      {/* Secure Login Route (2FA) */}
      <Route
        path='/v2/user/signin'
        element={isAuthenticated ? (
          <Navigate to="/v2/user/dashboard" />
        ) : (
          <Signin2FA
            setUser={setUser}
            userExist={userExist}
            forceLogout={forceLogoutMessage}
          />
        )}
      />

      {/* Default Route */}
      <Route path="*" element={<Navigate to="/v2/user/dashboard" />} />
    </Routes>
  );
};

export default UserRoutes;
